import InputField from './InputField'
import FormHeader from './FormHeader'
import FormFooter from './FormFooter'
import { css } from '@emotion/react'
import useSignin from '@src/hooks/auth/signin/useSignin'

const SigninForm = () => {
	const { getFormProps, getUsernameProps, getPasswordProps, getButtonProps } = useSignin({})

	const formStyle = css`
		width: 45rem;
	`
	const btnStyle = css`
		background: #ffcf19;
		color: #121212;
		display: inline-block;
		border: none;
		width: 100%;
		padding: 1.8rem 0;
		border-radius: 0.6rem;

		font-size: 1.8rem;
		font-weight: 500;
	`
	const labelStyle = css``
	return (
		<form css={formStyle} {...getFormProps()}>
			<FormHeader />
			<InputField
				title="아이디"
				name="username"
				{...getUsernameProps()}
				wrapperStyle={{ marginBottom: '1.4rem' }}
			/>
			<InputField
				title="비밀번호"
				name="password"
				type="password"
				{...getPasswordProps()}
				wrapperStyle={{ marginBottom: '1.4rem' }}
			/>
			{/* eslint-disable-next-line @typescript-eslint/no-unsafe-call */}
			<button css={btnStyle} type="submit" {...getButtonProps()}>
				로그인
			</button>
			<FormFooter />
		</form>
	)
}

export default SigninForm
